<template>
  <div class="news-manager">
    <div class="top">
      <el-radio-group
        v-model="type"
        @change="changeType"
      >
        <el-radio-button label>全部</el-radio-button>
        <el-radio-button label="course">課程</el-radio-button>
        <el-radio-button label="activity">活動</el-radio-button>
        <el-radio-button label="rank">榜單</el-radio-button>
        <el-radio-button label="private_school">升私中</el-radio-button>
      </el-radio-group>
      <el-button
        type="success"
        @click="createNews"
      >新增消息</el-button>
    </div>
    <div
      class="tips"
      style="margin: 15px 0"
    >
      圖片壓縮網址:
      <a
        href="https://tinyjpg.com/"
        target="_blank"
      >https://tinyjpg.com/</a>
    </div>
    <el-table
      :data="newsData.list"
      border
      stripe
      empty-text="沒有資料"
      style="width: 100%"
    >
      <el-table-column
        prop="thumbnail"
        label="預覽圖"
        width="200"
      >
        <template slot-scope="{ row }">
          <div class="center">
            <img
              class="thumbnail"
              :src="row.thumbnail"
              alt
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="short_description"
        label="標題"
        width="300"
      ></el-table-column>
      <el-table-column
        prop="type"
        label="類別"
        width="180"
      >
        <template slot-scope="{ row }">
          <div>{{ typeName(row.type) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="publish_date"
        label="發布日期"
        width="180"
      >
        <template slot-scope="{ row }">
          <div>{{ getDate(row.publish_date) }}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="修改"
        width="100"
      >
        <template slot-scope="{ row }">
          <div class="center">
            <el-button
              type="warning"
              @click="editNews(row)"
            >修改</el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="刪除"
        width="100"
      >
        <template slot-scope="{ row }">
          <div class="center">
            <el-button
              type="danger"
              @click="remove(row.id)"
            >刪除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-size="size"
      :total="newsData.total"
      :current-page.sync="currentPage"
      @current-change="pageChange"
    ></el-pagination>
    <NewsEditor
      :newsEditorVisible.sync="newsEditorVisible"
      :newsForm="newsForm"
      :isCreate="isCreate"
      @saveNews="saveNews"
    ></NewsEditor>
  </div>
</template>

<script>
import Api from "@/api/MaganmentApi";
import moment from "moment";
import _ from "lodash";
import Swal from "sweetalert2";
import NewsEditor from "@/components/management/NewsEditor";

export default {
  data() {
    return {
      newsEditorVisible: false,
      size: 10,
      currentPage: 1,
      type: "",
      newsData: {
        list: [],
        total: 0
      },
      isCreate: false,
      newsForm: {
        short_description: "",
        type: "",
        publish_date: undefined,
        thumbnail: "",
        content: ""
      }
    };
  },
  computed: {},
  methods: {
    init() {
      this.currentPage = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.type = this.$route.query.type ? this.$route.query.type : "";
      this.getNewsList();
    },
    async getNewsList() {
      const query = {
        type: this.type,
        page: this.currentPage,
        size: this.size,
        manager: true
      };
      const res = await Api.getNewsList(query);
      this.newsData = res.data;
    },
    getDate(timestamp) {
      let date = moment(timestamp).format("YYYY-MM-DD");
      return date;
    },
    typeName(type) {
      switch (type) {
        case "course":
          return "課程";
        case "activity":
          return "活動";
        case "rank":
          return "榜單";
        case "private_school":
          return "升私中";
        default:
          break;
      }
    },
    replaceQuery() {
      let newQuery = {
        type: this.type,
        page: this.currentPage
      };
      this.$router.replace({ query: newQuery });
    },
    pageChange() {
      this.replaceQuery();
      this.getNewsList();
    },
    changeType() {
      this.replaceQuery();
      this.getNewsList();
    },
    createNews() {
      this.isCreate = true;
      this.newsForm = {
        short_description: "",
        type: "",
        publish_date: undefined,
        thumbnail: "",
        content: ""
      };
      this.newsEditorVisible = true;
    },
    editNews(data) {
      this.isCreate = false;
      this.newsForm = _.cloneDeep(data);
      this.newsEditorVisible = true;
    },
    async saveNews(newsForm) {
      try {
        if (this.isCreate) {
          await Api.createNews(newsForm);
          this.init();
          this.newsEditorVisible = false;
          this.$message({
            message: "新增成功",
            type: "success"
          });
        } else {
          await Api.updateNews(newsForm);
          this.init();
          this.newsEditorVisible = false;
          this.$message({
            message: "修改成功",
            type: "success"
          });
        }
      } catch (e) {
        Swal.fire({
          title: "Error!",
          text: "發生錯誤，請檢查網路或聯絡管理人員",
          icon: "error"
        });
      }
    },
    async remove(id) {
      Swal.fire({
        title: "確定刪除？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "確定"
      }).then(async result => {
        if (result.value) {
          try {
            await Api.removeNews(id);
            _.remove(this.newsData.list, news => {
              return news.id == id;
            });
            this.$set(this.newsData.list, this.newsData.list);
            this.$message({
              message: "刪除成功",
              type: "success"
            });
          } catch (e) {
            Swal.fire({
              title: "Error!",
              text: "發生錯誤，請檢查網路或聯絡管理人員",
              icon: "error"
            });
          }
        }
      });
    }
  },
  created() {
    this.init();
  },
  mounted() {},
  components: {
    NewsEditor
  }
};
</script>

<style lang="scss" scoped>
.news-manager {
  .top {
    margin-bottom: 15px;
    display: flex;
    align-items: center;

    .el-radio-group {
      margin-right: 50px;
    }
  }
}
.thumbnail {
  width: 170px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
